import React, { useCallback, useState } from 'react';
import { useDidMount, useStateWithCallback } from "../../utils/hooks";
import { numToPrice, pexios } from '../../utils/functions';
import Pagination from "../../components/master/Pagination";
import allPrice01 from '../../assets/images/all-price01.png';
import distance01 from '../../assets/images/distance01.png';
import penelty01 from '../../assets/images/penelty01.png';
import allPrice02 from '../../assets/images/all-price02.png';
import distance02 from '../../assets/images/distance02.png';
import balance from '../../assets/images/balance.png';
import gift from '../../assets/images/gift.png';
import giftBox from "../../assets/images/giftBox.png";
import Reduction from "../../assets/images/recession.png"
import { useSelector } from 'react-redux';
import { history } from '../../utils/variables';
import { useTranslation } from 'react-i18next';

export default function Wallet() {

    const user = useSelector(store=> store.user)
    const [logs, setLogs] = useState([]);
    const [wallet, setWallet] = useState({});
    const [currentPage, setCurrentPage] = useStateWithCallback(1);
    const [lastPage, setLastPage] = useState(1);
    const [loader, setLoader] = useState(false);
    const { t } = useTranslation();

    const getWallet = useCallback(() => {
        pexios('/api/v2/get_wallet').then(res => {
            setWallet(res.data.data);
        });
    }, []);

    useDidMount(() => {
        getWallet();
        loadLogs();
    });

    function loadLogs(page = 1) {
        setLoader(true);
        pexios(`/api/v2/get_wallet_logs?page=${page}`)
            .then(res => {
                const result = res.data;
                setLoader(false);
                setLogs(result.data);
                setLastPage(result.meta.last_page);
            });
    }
    // function requestPay() {
    //     setLoader(true);
    //     pexios('/api/request_pay').then(()=>{
    //         setLoader(false);
    //         getWallet();
    //     });
    // }
    function changePage(page) {
        setCurrentPage(page, (currentPage) => loadLogs(currentPage));
    }

    return (
        <div className='content wallet'>
            {
                user.type !== 'expert' ?
                <>
                <div className='d-flex flex-column box-header mt20 p10' style={{border: '2px solid rgb(29, 209, 161)',borderRadius: '10px'}}>
                    <div className='p5 text-right' style={{fontSize: '14px'}}>
                        {t('Balance of digital wallet')}:<span style={user.my_wallet?.total_left < 0 ? {color: 'red'} : {}}>{numToPrice(user.my_wallet?.total_left || 0)} {t('rial')} </span>
                        <div className='payment-btn mt10 text-left'>
                            <button className='btn btn-green btn-circle' style={{fontSize: '11px'}} onClick={()=>history.replace('/payment')}>{t('Inventory increase')}<i className='fas fa-plus pl5' style={{color : 'white',fontSize: '12px'}}/></button>
                        </div>
                    </div>
                </div>
                </>
                :
               <>
            <div className='walletBox' style={{border: '3px solid #1dd1a1'}}>
                <h5 className="title text-center border-bottom pb5">{t('Cleared')}</h5>
                <div className='walletWrapper'>
                    <img src={allPrice01} alt=""/>
                    <p>{t('Total price')} :{wallet.total_pay && wallet.total_pay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
                </div>
                <div className='walletWrapper'>
                    <img src={gift} alt=""/>
                    <p>{t('Gift')} : {wallet.total_gift && wallet.total_gift.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
                </div>
                <div className='walletWrapper'>
                    <img src={penelty01} alt=""/>
                    <p>{t('Penalty')} : {wallet.total_penalty && wallet.total_penalty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
                </div>
                <div className='walletWrapper'>
                    <img src={distance01} alt=""/>
                    <p>{t('Distance')} : {wallet.dis_pay && wallet.dis_pay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('Kilometr')}</p>
                </div>
            </div>
            <div className='walletBox mt20' style={{border: '3px solid #ddb038'}}>
                <h5 className="title text-center border-bottom pb5">{t('Current Account')}</h5>
                <div className='walletWrapper'>
                    <img src={allPrice02} alt=""/>
                    <p> {t('Fees')} :{wallet.total_left && (wallet.total_left - wallet.penalty_left).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
                </div>
                {/* <div className='walletWrapper'>
                    <img src={Reduction} alt=""/>
                    <p> {t('Legal deductions')} :<span style={{color : 'red'}}>{wallet.total_left && ((wallet.total_left + (wallet.dis_left * wallet.transportation))*.1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}-</span> {t('rial')}</p>
                </div> */}
                <div className='walletWrapper'>
                    <img src={balance} alt=""/>
                    <p>{t('Balance of financial performance')}:{wallet.penalty_left && wallet.penalty_left.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
                </div>
                <div className='walletWrapper'>
                    <img src={distance02} alt=""/>
                    <p>{t('Distance')} : {wallet.dis_left && wallet.dis_left.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('Kilometr')}</p>
                </div>
            </div>
            <div className='final-price'>
                {/* <img src={allPrice02} alt=""/> */}
                <p>{t('Due price')}:<span style={{fontWeight : 'bold'}}>{wallet.total_left && ((wallet.total_left + (wallet.dis_left * wallet.transportation))).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> {t('rial')}</p>
            </div>
            </>
        }
            <div
                className='text-center'
            >
                <p className='text-center border-bottom m20 p10'>{t('Transaction list')}</p>
                <ul>
                    {
                        loader ?
                            <i className='fa fa-spinner fa-spin' /> :
                            logs.map((log, index) =>
                                log.content.includes(t('Price charge')) ?
                                    <li style={{backgroundColor: '#b2ebbc'}} key={index}>{log.content.split(" به پول کیف کارشناس "+user.full_name).join('')}</li> :
                                    log.content.includes(t('Checkout')) ?
                                    <li style={{backgroundColor: '#96d5f1'}} key={index}>{log.content}</li> :
                                        log.content.includes(t('Gift')) ?
                                        <li style={{backgroundColor: '#faf68f'}} key={index}>{log.content}</li> :
                                            log.content.includes(t('ََAward')) ?
                                            <div className='gift-box' key={index}>
                                                <img src={giftBox} alt="giftImage"/>
                                                <li className="wallet-gift"><i className='fas fa-gift pl10 ' style={{fontSize:"16px", color:"#ed03e6"}}/>{log.content}</li>
                                            </div>:
                                            <li style={{backgroundColor: '#ff7575'}} key={index}>{log.content}</li>
                            )
                    }
                </ul>
                <div className='mt20'>
                    <Pagination
                        currentPage={currentPage}
                        total={lastPage}
                        changePage={changePage}
                    />
                </div>
            </div>
        </div>
    );
}
